import { SelectListService } from "@js/services/SelectListService";
import {
  DeveloperExitFinanceDevScheduleInput,
  DeveloperExitFinanceDevScheduleInputClient,
  DeveloperExitFinanceLoanInput,
} from "@src/apis/ModularClient";

export class DeveloperExitFinanceDevScheduleInputController {
  selectedSection: string;

  objects: DeveloperExitFinanceDevScheduleInput[];
  selectedObject: DeveloperExitFinanceDevScheduleInput;

  loanInputs: DeveloperExitFinanceLoanInput;
  exitLoanCriteria: any; //Changed from DeveloperExitFinanceInputSet to any, change back if used.

  fetchingObjects: boolean;
  fetchingObject: boolean;

  totalUnitRentalPrice: number;
  totalUnitPrice: number;

  developerexitfinancedevscheduleinputForm: ng.IFormController;

  locationOptions = [];

  static $inject = [
    "$rootScope",
    "$location",
    "$routeParams",
    "DeveloperExitFinanceDevScheduleInputClient",
    "SelectListService",
  ];

  constructor(
    private $rootScope: ng.IRootScopeService,
    private $location: ng.ILocationService,
    private $routeParams: ng.route.IRouteParamsService,
    private developerExitFinanceDevScheduleInputClient: DeveloperExitFinanceDevScheduleInputClient,
    private selectListService: SelectListService,
  ) {
    this.updateObjects();

    this.locationOptions = this.selectListService.GetLocations();
  }

  updateObjects() {
    this.fetchingObjects = true;
    if ((this.$rootScope as any).exitLoanCriteria) {
      this.exitLoanCriteria = (this.$rootScope as any).exitLoanCriteria;
      this.objects = this.exitLoanCriteria.DevelopmentInput.DevelopmentSchedules;
    } else {
      this.exitLoanCriteria = {} as any; //Changed from DeveloperExitFinanceInputSet to any, change back if used.
      this.objects = [];
      this.addUnit();
    }
    //this.$developerexitfinancedevscheduleinputservice.fetchAll().then((response) => {
    //    this.objects = response;
    //    this.preSelectedItem();
    //}).finally(() => {
    //    this.fetchingObjects = false;
    //});
  }

  private preSelectedItem() {
    if (this.$routeParams.Id) {
      let selectedObject = this.objects.find((value, index) => {
        return value.id === parseInt(this.$routeParams.objectId);
      });

      this.selectObject(selectedObject);
    }
  }

  calcTotalUnitPrice() {
    var res: number = 0;
    this.objects.forEach((item) => {
      if (item.salesPrice) {
        res += Number(item.salesPrice);
      }
    });
    this.totalUnitPrice = res;
  }
  calcTotalUnitRentalPrice() {
    var res: number = 0;
    this.objects.forEach((item) => {
      if (item.monthlyRent) {
        res += Number(item.monthlyRent);
      }
    });
    this.totalUnitRentalPrice = res;
  }

  selectObject(object: DeveloperExitFinanceDevScheduleInput) {
    this.selectedObject = object;

    this.selectedSection = "details";
  }

  createObject() {
    this.selectedSection = "details";
    this.selectedObject = {} as DeveloperExitFinanceDevScheduleInput;
  }

  addUnit() {
    this.selectedObject = {} as DeveloperExitFinanceDevScheduleInput;
    this.objects.push(this.selectedObject);
  }

  save() {
    this.developerExitFinanceDevScheduleInputClient.addUpdateList(this.objects).then((response) => {
      //this.selectedObject.Id = response;
      if (!this.objects) {
        this.objects = [];
      }

      this.developerexitfinancedevscheduleinputForm.$setPristine();
      this.updateObjects();
    });
  }

  deleteUnit(item: DeveloperExitFinanceDevScheduleInput) {
    //this.$developerexitfinancedevscheduleinputservice.delete(item.Id).then((response) => {
    //    if (response) {
    this.objects.splice(this.objects.indexOf(item), 1);
    this.developerexitfinancedevscheduleinputForm.$setPristine();
    //    }
    //});
  }

  delete() {
    this.developerExitFinanceDevScheduleInputClient.markAsDeleted(this.selectedObject.id).then((response) => {
      if (response) {
        this.objects.splice(this.objects.indexOf(this.selectedObject), 1);
        this.developerexitfinancedevscheduleinputForm.$setPristine();
        delete this.selectedObject;
      }
    });
  }

  fetchResults() {
    this.exitLoanCriteria.DevelopmentInput.DevelopmentSchedules = this.objects;
    this.exitLoanCriteria.DevelopmentInput.HowManyUnits =
      this.exitLoanCriteria.DevelopmentInput.DevelopmentSchedules.length;
    (this.$rootScope as any).exitLoanCriteria = this.exitLoanCriteria;
    this.$location.path("/exitloanresults");
  }
}
